import BaseController from "confinus_ui/base_controller";

export default class extends BaseController {
  static values = {
    url: String,
  };

  static targets = ["button", "result"];

  declare urlValue: string;
  declare buttonTarget: HTMLElement;
  declare resultTarget: HTMLElement;

  async validate(): Promise<void> {
    this.buttonTarget.setAttribute("disabled", "true");
    this.resultTarget.classList.remove("hidden");
    this.resultTarget.className = "text-sm text-gray-500 font-medium";
    this.resultTarget.textContent = "Validating (fetching DTD)...";

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken(),
          Accept: "application/json",
        },
      });

      const data = await response.json();

      this.buttonTarget.removeAttribute("disabled");

      if (data.valid) {
        const dtdNote = data.dtd_validated
          ? `Valid against DTD (${data.dtd_url})`
          : "Well-formed XML";
        const warning =
          data.warnings && data.warnings.length > 0
            ? ` — ${data.warnings.join("; ")}`
            : "";

        if (warning) {
          this.resultTarget.className = "text-sm text-amber-600 font-medium";
          this.resultTarget.textContent = `${dtdNote}${warning}`;
        } else {
          this.resultTarget.className = "text-sm text-green-600 font-medium";
          this.resultTarget.textContent = dtdNote;
        }
      } else {
        this.resultTarget.className = "text-sm text-red-600 font-medium";
        this.resultTarget.textContent = data.errors.join("; ");
      }
    } catch (error) {
      this.buttonTarget.removeAttribute("disabled");
      this.resultTarget.className = "text-sm text-red-600 font-medium";
      this.resultTarget.textContent = "Validation request failed";
    }
  }

  private csrfToken(): string {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta?.getAttribute("content") ?? "";
  }
}
